function initializePlanBlock() {
document.addEventListener("DOMContentLoaded", function () {
    const planBlock = document.getElementById("plan-block");

    if (!planBlock) return; 

    const buttons = planBlock.querySelectorAll("[data-feature-filter]");
    const planDetails = planBlock.querySelectorAll(".plan-parent");

    if (buttons.length > 0) {
        buttons[0].classList.add("active");
        const firstCategory = buttons[0].getAttribute("data-feature-filter");

        planDetails.forEach(detail => {
            if (detail.classList.contains(firstCategory)) {
                detail.classList.add("active");
            } else {
                detail.style.display = "none";
            }
        });

        buttons.forEach(button => {
            button.addEventListener("click", function () {
                const selectedCategory = this.getAttribute("data-feature-filter");

                buttons.forEach(btn => btn.classList.remove("active"));
                this.classList.add("active"); 

                planDetails.forEach(detail => {
                    if (detail.classList.contains(selectedCategory)) {
                        detail.style.display = "block";
                    } else {
                        detail.style.display = "none";
                    }
                });
            });
        });
    }
});
}

export default initializePlanBlock;